// @TODO: remove

import Header from '../../../landing/components/Header';

export default Header;
